import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28.409 28.122" {...props}>
      <defs>
        <style>
          {`.prefix__prefix__cls-1menusummaryicon{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round}`}
        </style>
      </defs>
      <g
        id="prefix__prefix__Group_2519"
        data-name="Group 2519"
        transform="translate(-454.677 -205.479)"
      >
        <g
          id="prefix__prefix__Group_2521"
          data-name="Group 2521"
          transform="translate(455.177 206.177)"
        >
          <g
            id="prefix__prefix__Group_2520"
            data-name="Group 2520"
            transform="translate(7.714 .941)"
          >
            <path
              id="prefix__prefix__Path_3588"
              d="M896.031 236.379a6.79 6.79 0 01-.446 2.075 2.089 2.089 0 001.8.586c1.758-.415 1.486 1.037 1.014 1.912s-1.537 1.9-2.155.2a2.087 2.087 0 00-1.477-1.184 6.786 6.786 0 01-1.541 1.547"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3588"
              transform="translate(-879.23 -226.008)"
            />
            <path
              id="prefix__prefix__Path_3589"
              d="M894.161 227.768a2.815 2.815 0 003.063-.758c.951-1.536 1.784-.318 2.069.635s.255 2.43-1.382 1.666a2.814 2.814 0 00-2.977 1.045"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3589"
              transform="translate(-879.744 -220.454)"
            />
            <path
              id="prefix__prefix__Path_3590"
              d="M890.277 220.061a6.765 6.765 0 00-1.511-1.491 2.087 2.087 0 011.185-1.477c1.7-.618.674-1.682-.2-2.155s-2.326-.745-1.912 1.014a2.086 2.086 0 01-.586 1.8 6.785 6.785 0 00-2.136-.449"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3590"
              transform="translate(-874.771 -214.024)"
            />
            <path
              id="prefix__prefix__Path_3591"
              d="M883.7 246.663a2.86 2.86 0 011.1 3.11c-.842 1.725.968 1.676 2 1.368s2.573-1.26.923-2.241a2.86 2.86 0 01-.787-3.2"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3591"
              transform="translate(-873.991 -231.131)"
            />
            <path
              id="prefix__prefix__Path_3592"
              d="M870.7 244.749a6.764 6.764 0 001.511 1.491 2.087 2.087 0 01-1.184 1.477c-1.7.618-.675 1.682.2 2.155s2.326.745 1.912-1.014a2.086 2.086 0 01.586-1.8 6.788 6.788 0 002.136.449"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3592"
              transform="translate(-866.521 -230.609)"
            />
            <path
              id="prefix__prefix__Path_3593"
              d="M866.631 236.165a2.814 2.814 0 01-2.977 1.045c-1.637-.764-1.667.713-1.382 1.666s1.118 2.172 2.069.635a2.815 2.815 0 013.063-.758"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3593"
              transform="translate(-862.136 -225.89)"
            />
            <path
              id="prefix__prefix__Path_3594"
              d="M875.27 218.951a2.754 2.754 0 00-.787-3.2c-1.65-.981-.109-1.932.923-2.241s2.843-.357 2 1.368a2.764 2.764 0 001.1 3.11"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3594"
              transform="translate(-868.526 -213.341)"
            />
            <path
              id="prefix__prefix__Path_3595"
              d="M865.22 228.173a6.786 6.786 0 01.446-2.075 2.089 2.089 0 00-1.8-.586c-1.759.415-1.487-1.037-1.014-1.912s1.537-1.9 2.155-.2a2.089 2.089 0 001.477 1.184 6.789 6.789 0 011.541-1.547"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3595"
              transform="translate(-862.335 -218.368)"
            />
            <path
              id="prefix__prefix__Path_3596"
              d="M890.345 236.931a1.351 1.351 0 10-.908 1.681 1.351 1.351 0 00.908-1.681z"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3596"
              transform="translate(-876.191 -225.781)"
            />
            <path
              id="prefix__prefix__Path_3597"
              d="M886.812 228.594a1.351 1.351 0 10-.908 1.68 1.351 1.351 0 00.908-1.68z"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3597"
              transform="translate(-874.249 -221.196)"
            />
            <path
              id="prefix__prefix__Path_3598"
              d="M876.658 229.538a1.35 1.35 0 10-.907 1.681 1.35 1.35 0 00.907-1.681z"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3598"
              transform="translate(-868.666 -221.716)"
            />
            <path
              id="prefix__prefix__Path_3599"
              d="M880.477 238.834a1.35 1.35 0 10-.908 1.681 1.35 1.35 0 00.908-1.681z"
              className="prefix__prefix__cls-1menusummaryicon"
              data-name="Path 3599"
              transform="translate(-870.766 -226.827)"
            />
          </g>
          <path
            id="prefix__prefix__Path_3600"
            d="M862.323 234.243a37.639 37.639 0 01-6.053 3.931c-.636-.165-11.27-6.4-11.27-10.645v-11.9c3.18 0 10.157-2.847 11.27-4.383"
            className="prefix__prefix__cls-1menusummaryicon"
            data-name="Path 3600"
            transform="translate(-845 -211.25)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
